import loggerService from './loggerService';

const getMainConfig = () => {
  try {
    return window.mainConfig;
  } catch (error) {
    loggerService.error(error);
    return null;
  }
};

export const hasFeature = (key) => {
  const mainConfig = getMainConfig();
  if (!mainConfig) return false;

  return (
    (mainConfig?.merchantData?.beta_feature_keys || []).includes(key) ||
    (mainConfig?.merchantData?.rollout_keys || []).includes(key)
  );
};

export const hasBetaFeature = (key) => {
  const mainConfig = getMainConfig();
  if (!mainConfig?.merchantData?.beta_feature_keys) return false;
  return mainConfig.merchantData.beta_feature_keys.includes(key);
};

export const hasRolloutFeature = (key) => {
  const mainConfig = getMainConfig();
  return (mainConfig?.merchantData?.rollout_keys || []).includes(key);
};

export const getSetting = (key, defaultValue = 0) => {
  const mainConfig = getMainConfig();
  if (!mainConfig) return defaultValue;

  const currentBasePlan = getBasePlan(mainConfig.merchantData.current_plan_key);
  return mainConfig.features?.plans?.[currentBasePlan]?.[key] ?? defaultValue;
};

export const getBasePlan = (value) => {
  return value?.split('_')[0];
};
